import React from 'react';
import { Button } from 'primereact/button';
import { LdapGroupInfo } from 'shared';
import { GroupPicker } from '../GroupPicker';

interface GroupsStepProps {
  groups: LdapGroupInfo[];
  selected: string[];
  onChange: (groups: string[]) => void;
  onBack: () => void;
  onNext: () => void;
}

export const GroupsStep: React.FC<GroupsStepProps> = ({
  groups,
  selected,
  onChange,
  onBack,
  onNext,
}) => (
  <div data-component="ldap-wizard-groups" className="flex flex-col gap-4">
    <GroupPicker groups={groups} selected={selected} onChange={onChange} />
    <div className="flex justify-between pt-2">
      <Button label="Back" icon="pi pi-arrow-left" className="p-button-text" onClick={onBack} />
      <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={onNext} />
    </div>
  </div>
);
